import React from 'react';
import { styled, type SxProps, type Theme } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import clsx from 'clsx';

const BoxStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(8),
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  zIndex: 1,
}));

type Props = {
  className?: string;
  sx?: SxProps<Theme>;
};

const SpinnerOverlay = ({ className, sx }: Props) => {
  return (
    <BoxStyled className={clsx('spinner-overlay', className)} sx={sx}>
      <CircularProgress color="secondary" size="4rem" />
    </BoxStyled>
  );
};

export default SpinnerOverlay;
